export default __webpack_public_path__ + "static/media/ev-sales.0c1d2ee5.png";